export default __webpack_public_path__ + "static/media/carousel-msg-icon.5c7770ba.png";